import { render, staticRenderFns } from "./Dialogbox.vue?vue&type=template&id=1c2878c7&"
import script from "./Dialogbox.vue?vue&type=script&lang=js&"
export * from "./Dialogbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports